// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SettingsBlock__objects___Gxgos {
    grid-row: span var(--number-of-rows);

    & .SettingsBlock__list___U5CJw {
        display: flex;
        flex-direction: column;
        gap: var(--space-xs);
    }
}

.SettingsBlock__block___KGwPl {
    display: flex;
    flex-direction: column;
    gap: var(--space-xs);
}

.SettingsBlock__blockHeader___psueX {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.SettingsBlock__blockHeaderLeft___dyePV {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.SettingsBlock__divider___vBdoy {
    display: block;
    align-self: center;

    width: 100%;
    height: 0.1rem;

    border-bottom: 0.1rem solid var(--color-bg-border);
    border-left: 0.1rem solid var(--color-bg-border);
}

.SettingsBlock__input___p9lzX {
    width: 9.2rem;

    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */
    & .TextField-Input {
        min-width: 4rem;
    }
}

.SettingsBlock__doubleInputContainer___L8WVs {
    display: inline-flex;
    gap: var(--space-2xs);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/model/Actions/CommonRenderers/Settings/SettingsBlock/SettingsBlock.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;;IAEpC;QACI,aAAa;QACb,sBAAsB;QACtB,oBAAoB;IACxB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;;IAElB,WAAW;IACX,cAAc;;IAEd,kDAAkD;IAClD,gDAAgD;AACpD;;AAEA;IACI,aAAa;;IAEb,uEAAuE;IACvE;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB","sourcesContent":[".objects {\n    grid-row: span var(--number-of-rows);\n\n    & .list {\n        display: flex;\n        flex-direction: column;\n        gap: var(--space-xs);\n    }\n}\n\n.block {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-xs);\n}\n\n.blockHeader {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.blockHeaderLeft {\n    display: flex;\n    gap: 1rem;\n    align-items: center;\n}\n\n.divider {\n    display: block;\n    align-self: center;\n\n    width: 100%;\n    height: 0.1rem;\n\n    border-bottom: 0.1rem solid var(--color-bg-border);\n    border-left: 0.1rem solid var(--color-bg-border);\n}\n\n.input {\n    width: 9.2rem;\n\n    /* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n    & :global(.TextField-Input) {\n        min-width: 4rem;\n    }\n}\n\n.doubleInputContainer {\n    display: inline-flex;\n    gap: var(--space-2xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"objects": `SettingsBlock__objects___Gxgos`,
	"list": `SettingsBlock__list___U5CJw`,
	"block": `SettingsBlock__block___KGwPl`,
	"blockHeader": `SettingsBlock__blockHeader___psueX`,
	"blockHeaderLeft": `SettingsBlock__blockHeaderLeft___dyePV`,
	"divider": `SettingsBlock__divider___vBdoy`,
	"input": `SettingsBlock__input___p9lzX`,
	"doubleInputContainer": `SettingsBlock__doubleInputContainer___L8WVs`
};
export default ___CSS_LOADER_EXPORT___;
